import {useAdmins} from "../../hooks";
import DataTable from "../../components/dataTables/DataTable";
import {LeftSideMenu} from "../../components/leftSideMenu/LeftSideMenu";
import {useContext, useState} from "react";
import {buildColDefs} from "../../components/dataTables/buildColDefs";
import {CreationForm, CreationFormTemplate} from "../../components/form/CreationForm";
import {TabbedContent} from "../../components/tabs/TabbedContent";
import {Admin} from "../../data-parsing/admins/Admin";
import {AddAdminFormTemplate} from "../../data-parsing/admins/FormTemplate";
import {User} from "../../data-parsing/users/User";
import {ResponseStatus, StatusContextApi} from "../../context/status";
import {getKeyByValue} from "../../data-parsing/parseUtils";

export function Admins() {
    const [query, setQuery] = useState(null);
    const {admins, createAdmin, deleteAdmin, updateAdmin} = useAdmins(query);
    let colDefs = buildColDefs(Admin);
    const {addMessage} = useContext(StatusContextApi);

    function validateFields(formData) {
        if(formData.get(getKeyByValue(User, User.password)) !== formData.get(getKeyByValue(User, User.passwordVerification))){
            addMessage(ResponseStatus.ERROR, 5000, "Los valores de contraseña introducidos no coinciden");
            return false;
        }
        return true;
    }

    return <LeftSideMenu active="admins">
        <div id="wrapper">

            <div className="container">
                <div className="row">

                    <div className="col-xs-12">
                        <div className="card-box card-tabs m-t-20">
                            <h4 className="header-title m-t-0 m-b-30 pull-right">ADMINS</h4>
                            <TabbedContent tabHeaders={[
                                <button data-toggle="tab" aria-expanded="true"><i
                                    className="fas fa-plus-circle"></i> NUEVO ADMIN</button>,
                                <button data-toggle="tab" aria-expanded="false"
                                   onClick={() => setQuery(0)}><i
                                    className="far fa-eye"></i> LISTAR ADMINS</button>,
                            ]}>
                                <div className="fade in ">
                                    <div className="row">
                                        <CreationForm createFunction={createAdmin} validateForm={validateFields}>
                                            <CreationFormTemplate formTemplate={AddAdminFormTemplate}
                                                                  dataTemplate={Admin}/>

                                            <div className="col-sm-12">
                                                <button className="btn btn-rounded btn-purple m-t-20 ml-10">
                                                    <i className="far fa-save"></i> Guardar
                                                    Admin
                                                </button>
                                            </div>

                                        </CreationForm>
                                    </div>
                                </div>

                                <div className="fade in">
                                    <DataTable colDefs={colDefs} data={admins} dataId={"Aliments"} resizable={true}
                                               allowHiddenColumns={true} scrollX={false}
                                               deleteElement={deleteAdmin} editElement={updateAdmin}
                                               className="table table-bordered panel-group"/>
                                </div>
                            </TabbedContent>

                        </div>
                    </div>

                </div>
            </div>

        </div>
    </LeftSideMenu>
}